<template>
  <div class="systemDoor">
    <div class="systemDoorBox">
      <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-bottom: 20px">
        <el-tab-pane label="检查项" name="checkOption"></el-tab-pane>
        <el-tab-pane label="问卷分类" name="category"></el-tab-pane>
      </el-tabs>

      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="searchData()">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="clearFilter()">重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="8">
          <span class="label">名称</span>
          <el-input
            v-model="filterData.name"
            placeholder=""
            style="width: auto"
          ></el-input>
        </el-col>
        <el-col :span="8">
          <span class="label">题目分类</span>
          <el-select
            class="area"
            v-model="filterData.type"
            placeholder="请选择分类"
          >
            <el-option
              v-for="item in categoryList"
              :key="item.type"
              :label="item.name"
              :value="item.type">
            </el-option>
          </el-select>
        </el-col>

      </el-row>
      <el-divider></el-divider>

      <el-row>
        <el-col :span="22">数据列表</el-col>
        <el-col :span="2">
          <el-button
            plain
            round
            icon="el-icon-upload2"
            size="small"
            style="color: #67C23A"
            @click="openEdit(null)">
            新 建
          </el-button>
        </el-col>
        <!--        <el-col :span="2">-->
        <!--          <el-button-->
        <!--            plain-->
        <!--            round-->
        <!--            icon="el-icon-download"-->
        <!--            size="small"-->
        <!--            style="color: #67C23A"-->
        <!--            @click="exportExcel"-->
        <!--          >-->
        <!--            导 出-->
        <!--          </el-button>-->
        <!--        </el-col>-->
      </el-row>

      <el-table
        style="width: 100%; margin-top: 20px"
        fit
        stripe
        :data="tableData"
        v-loading="tableLoading"
        border
      >
        <el-table-column
          sortable
          prop="name"
          label="名称"
        ></el-table-column>
        <el-table-column
          sortable
          prop="type"
          label="分类"
          width="150"
        >
          <template slot-scope="scope">
            {{ convertType(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" style="color: #606266" icon="el-icon-edit" size="mini" @click="openEdit(scope.row)"
            >编辑</el-button>
            <el-button type="text" style="color: #606266" icon="el-icon-delete" size="mini" @click="onDelete(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="tableConfig.current"
          :total="total"
        ></el-pagination>
      </footer>
    </div>

    <el-dialog
      title="新增/编辑 检查项"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div>
        <el-form :model="form">
          <el-form-item label="检查项名称" label-width="120px">
            <el-input style="width: 300px" v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="题目分类" label-width="120px">
            <el-select style="width: 300px" v-model="form.type" placeholder="请选择分类">
              <el-option
                v-for="item in categoryList"
                :key="item.type"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="save()" round >提 交</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";

export default {
  name: "SystemManageOne",
  data() {
    return {
      activeName: "checkOption",
      dialogVisible: false,
      currentId: '',
      filterData: {},
      initialFilterData: {
        type: "", //分类
        name: "" //搜索项
      },
      categoryList: [
        {
          name: '陈列',
          type: 1
        },
        {
          name: '运营',
          type: 2
        },
        {
          name: '培训',
          type: 3
        },
      ],
      form: {
        name: '',
        type: '',
      },
      tableData: [], // 列表
      total: 10, // 总数量
      tableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
      },
      tableLoading: false
    }
  },
  mounted() {
    this.getData();
    this.clearFilter();
  },
  methods: {
    clearFilter() {
      this.filterData = _.cloneDeep(this.initialFilterData);
    },
    handleClick(tab, event){
      if (tab.name === "category"){
        this.$router.push("/opr/systemManageTwo")
      }
    },
    searchData() {
      this.tableConfig.current = 1;
      this.getData();
    },
    async getData() {
      // 获取列表
      this.tableLoading = true;
      const params = _.assign({}, this.tableConfig, this.filterData);
      let res = await axios.post(oprReqUrl+"/checkitem/search", params);
      res = res.data;
      if (res.code === 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total;
      }
      this.tableLoading = false;
    },
    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
    },
    openEdit(row) {
      this.dialogVisible = true
      if (row) {
        this.form = row
        this.currentId = row.id
      } else {
        this.form = {
          name: '',
          type: '',
        }
        this.currentId = null
      }
    },
    async onDelete(id) {
      this.$confirm("确认删除吗？", "提示",{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async() => {
          let res = await axios.post(oprReqUrl+"/checkitem/delete", {id});
          res = res.data
          if (res.code === 200) {
            await this.getData()
            this.$message.success(res.message)
          }else {
            this.$message.warning(res.message)
          }
        })
        .catch(_ => {})
    },
    async save() {
      const params = _.assign(this.form, { id: this.currentId });
      let res = await axios.post(oprReqUrl+"/checkitem/save", params);
      res = res.data;
      if (res.code === 200) {
        this.$message.success(res.message)
        this.getData();
        this.dialogVisible = false
      }
      this.tableLoading = false;
    },
    convertType(type) {
      if (type === 1) {
        return '陈列'
      } else if (type === 2) {
        return '运营'
      } else if (type === 3) {
        return '培训'
      }
    }
  }
};
</script>
<style lang="sass" scoped>
.systemDoor
  min-width: 1050px
  input[type=file]
    display: none
  .systemDoorBox
    padding: 20px
    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px
    .filter
      margin-top: 30px
    .label
      font-size: 14px
      color: #606266
    .table-container
      margin-top: 20px
    footer
      padding-top: 20px
      text-align: right
</style>



// WEBPACK FOOTER //
// src/opr/pages/views/systemManageOne.vue